import React from 'react'

import { ChatMessageLinkedResponseFragment } from '../../feedQueries.generated'
import { useMentionResponse } from '../../mentionResponse'
import { useMentionLesson } from '../../mentionLesson'
import { CardActionsMenu } from '../../../designSystem'

export type ResponseActionsProps = {
  linkedResponse: ChatMessageLinkedResponseFragment
}

export default function ResponseActions({ linkedResponse }: ResponseActionsProps) {
  const { setResponse } = useMentionResponse()
  const { removeLesson } = useMentionLesson()
  const actions = [
    {
      label: 'Comment in chat',
      onClick: () => {
        removeLesson()
        setResponse(linkedResponse)
      },
    },
  ]
  return <CardActionsMenu actions={actions} />
}
